/**
 * @generated SignedSource<<2769d25954b2349cdf6fc37ddd31c0ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScriptTagSettingTabContainer_site$data = {
  readonly id: string;
  readonly embedTag: string | null;
  readonly robeeTag: string;
  readonly userTagDraft: string | null;
  readonly userTagPublishedModule: {
    readonly id: string;
    readonly versionNumber: number;
    readonly tagContent: string | null;
    readonly status: string;
    readonly description: string | null;
    readonly authorName: string | null;
    readonly publishedAt: string | null;
    readonly createdAt: string;
  } | null;
  readonly userTagModules: ReadonlyArray<{
    readonly id: string;
    readonly versionNumber: number;
    readonly tagContent: string | null;
    readonly status: string;
    readonly description: string | null;
    readonly authorName: string | null;
    readonly publishedAt: string | null;
    readonly createdAt: string;
    readonly name: string;
    readonly enabled: boolean;
    readonly priority: number;
    readonly draftContent: string | null;
    readonly draftEnabled: boolean | null;
    readonly hasDraft: boolean;
    readonly hasPendingToggle: boolean;
    readonly hasPendingChanges: boolean;
    readonly effectiveEnabled: boolean;
    readonly isDistributionGated: boolean;
    readonly isDraftDistributionGated: boolean;
    readonly hasPendingLinkChange: boolean;
    readonly isArchive: boolean;
    readonly deletedAt: string | null;
    readonly popupGroups: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly abtestScenarioPageGroups: ReadonlyArray<{
      readonly id: string;
      readonly title: string;
    }>;
    readonly draftPopupGroups: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly draftAbtestScenarioPageGroups: ReadonlyArray<{
      readonly id: string;
      readonly title: string;
    }>;
  }>;
  readonly popupGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly page: {
          readonly funnel: {
            readonly id: string;
            readonly name: string;
          };
        };
      } | null;
    } | null> | null;
  };
  readonly abtestScenarioPageGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly title: string;
        readonly page: {
          readonly funnel: {
            readonly id: string;
            readonly name: string;
          };
        };
      } | null;
    } | null> | null;
  };
  readonly enabledUserTagModules: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly enabled: boolean;
    readonly priority: number;
    readonly tagContent: string | null;
  }>;
  readonly mergedTagPreview: string | null;
  readonly draftMergedTagPreview: string | null;
  readonly enabledModuleCount: number;
  readonly totalModuleCount: number;
  readonly hasPendingChanges: boolean;
  readonly hasWorkspaceDeployDrift: boolean;
  readonly userTagWorkspacePendingChangeSummary: {
    readonly codeDraftModuleNames: ReadonlyArray<string>;
    readonly addedModuleNames: ReadonlyArray<string>;
    readonly removedModuleNames: ReadonlyArray<string>;
    readonly toggleChanges: ReadonlyArray<{
      readonly moduleName: string;
      readonly fromLabel: string;
      readonly toLabel: string;
    }>;
    readonly linkChanges: ReadonlyArray<{
      readonly moduleName: string;
      readonly fromLabel: string;
      readonly toLabel: string;
    }>;
  } | null;
  readonly userTagVersions: ReadonlyArray<{
    readonly id: string;
    readonly versionName: string;
    readonly description: string | null;
    readonly authorName: string | null;
    readonly isActive: boolean;
    readonly createdAt: string;
    readonly content: string;
    readonly changeSummary: {
      readonly codeDraftModuleNames: ReadonlyArray<string>;
      readonly addedModuleNames: ReadonlyArray<string>;
      readonly removedModuleNames: ReadonlyArray<string>;
      readonly toggleChanges: ReadonlyArray<{
        readonly moduleName: string;
        readonly fromLabel: string;
        readonly toLabel: string;
      }>;
      readonly linkChanges: ReadonlyArray<{
        readonly moduleName: string;
        readonly fromLabel: string;
        readonly toLabel: string;
      }>;
    } | null;
    readonly modulesSnapshot: ReadonlyArray<{
      readonly moduleId: number;
      readonly name: string | null;
      readonly enabled: boolean;
      readonly priority: number;
      readonly gated: boolean | null;
      readonly tagContent: string | null;
    }> | null;
  }>;
  readonly activeUserTagVersion: {
    readonly id: string;
    readonly versionName: string;
    readonly description: string | null;
    readonly authorName: string | null;
    readonly isActive: boolean;
    readonly createdAt: string;
  } | null;
  readonly " $fragmentType": "ScriptTagSettingTabContainer_site";
};
export type ScriptTagSettingTabContainer_site = ScriptTagSettingTabContainer_site$data;
export type ScriptTagSettingTabContainer_site$key = {
  readonly " $data"?: ScriptTagSettingTabContainer_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScriptTagSettingTabContainer_site">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tagContent",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingChanges",
  "storageKey": null
},
v12 = [
  (v0/*: any*/),
  (v8/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = [
  (v0/*: any*/),
  (v13/*: any*/)
],
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": (v12/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "moduleName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toLabel",
    "storageKey": null
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "codeDraftModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "removedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "toggleChanges",
    "plural": true,
    "selections": (v17/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "linkChanges",
    "plural": true,
    "selections": (v17/*: any*/),
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScriptTagSettingTabContainer_site",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "embedTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "robeeTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userTagDraft",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTagModule",
      "kind": "LinkedField",
      "name": "userTagPublishedModule",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTagModule",
      "kind": "LinkedField",
      "name": "userTagModules",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "draftContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "draftEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasDraft",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPendingToggle",
          "storageKey": null
        },
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "effectiveEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDistributionGated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isDraftDistributionGated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPendingLinkChange",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isArchive",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deletedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupGroup",
          "kind": "LinkedField",
          "name": "popupGroups",
          "plural": true,
          "selections": (v12/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AbtestScenarioPageGroup",
          "kind": "LinkedField",
          "name": "abtestScenarioPageGroups",
          "plural": true,
          "selections": (v14/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupGroup",
          "kind": "LinkedField",
          "name": "draftPopupGroups",
          "plural": true,
          "selections": (v12/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AbtestScenarioPageGroup",
          "kind": "LinkedField",
          "name": "draftAbtestScenarioPageGroups",
          "plural": true,
          "selections": (v14/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v15/*: any*/),
      "concreteType": "PopupGroupConnection",
      "kind": "LinkedField",
      "name": "popupGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PopupGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v8/*: any*/),
                (v16/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "popupGroups(first:500)"
    },
    {
      "alias": null,
      "args": (v15/*: any*/),
      "concreteType": "AbtestScenarioPageGroupConnection",
      "kind": "LinkedField",
      "name": "abtestScenarioPageGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AbtestScenarioPageGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AbtestScenarioPageGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v13/*: any*/),
                (v16/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "abtestScenarioPageGroups(first:500)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTagModule",
      "kind": "LinkedField",
      "name": "enabledUserTagModules",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mergedTagPreview",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "draftMergedTagPreview",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabledModuleCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalModuleCount",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWorkspaceDeployDrift",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTagWorkspacePendingChangeSummary",
      "kind": "LinkedField",
      "name": "userTagWorkspacePendingChangeSummary",
      "plural": false,
      "selections": (v18/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTagVersion",
      "kind": "LinkedField",
      "name": "userTagVersions",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v19/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v20/*: any*/),
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserTagWorkspacePendingChangeSummary",
          "kind": "LinkedField",
          "name": "changeSummary",
          "plural": false,
          "selections": (v18/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserTagVersionModuleSnapshot",
          "kind": "LinkedField",
          "name": "modulesSnapshot",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleId",
              "storageKey": null
            },
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "gated",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserTagVersion",
      "kind": "LinkedField",
      "name": "activeUserTagVersion",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v19/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v20/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "a78d5a77f1ba3ae99c18d8133230581d";

export default node;
